import { Navigate, useSearchParams } from "react-router-dom";
import { useI18n } from "./i18n";
import { ManagementHeader, type ManagementPageProps } from "./managementUI";
import { AlertCenter } from "./monitoring/AlertCenter";
import { useMonitoringData } from "./monitoring/useMonitoringData";
import { date } from "./monitoring/model";
import "./monitoring/monitoring.css";

export function AlertsPage(props: ManagementPageProps) {
  const [params] = useSearchParams();
  const legacy = params.get("alerts_tab");
  if (legacy === "audit" || legacy === "history") {
    const next = new URLSearchParams(params);
    next.set("alerts_tab", "active");
    if (legacy === "audit") next.set("drawer", "audit");
    else next.set("event_status", "resolved");
    return <Navigate replace to={`/alerts?${next}`} />;
  }
  return <AlertsContent {...props} />;
}
function AlertsContent({ session, refreshKey }: ManagementPageProps) {
  const { t } = useI18n();
  const { data, now, loading, refresh } = useMonitoringData(
    refreshKey,
    "alerts",
  );
  return (
    <div className="page-stack monitor-page">
      <ManagementHeader
        eyebrow="ALERTS"
        title={t("告警中心", "Alert center")}
        description={t(
          "查看告警、配置通知并管理静默。",
          "Review alerts, configure notifications, and manage silences.",
        )}
      />
      <div className="monitor-context alert-page-context">
        <strong>{data.components.data?.data_center_id || "—"}</strong>
        <span>
          {t("最近同步", "Last sync")}{" "}
          {date(
            data.alerts.fetchedAt
              ? new Date(data.alerts.fetchedAt).toISOString()
              : null,
          )}
        </span>
        <button
          className="secondary-button"
          disabled={loading}
          onClick={() => void refresh()}
        >
          {t("刷新", "Refresh")}
        </button>
      </div>
      <AlertCenter data={data} now={now} session={session} refresh={refresh} />
    </div>
  );
}
